import styled from "styled-components"
import BaseInput from "../../atoms/BaseInput"
import SearchIcon from '@mui/icons-material/Search';
import MicRoundedIcon from '@mui/icons-material/MicRounded';

const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.neutral[200]};
  width: 100%;
  min-height: 50px;
  border-radius: 10px;
`

const LeadingIcon = styled(SearchIcon)`
  color: ${(props) => props.theme.colors.normal};
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
`

const TailingIconButton = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const MicIcon = styled(MicRoundedIcon)`
  color: ${(props) => props.theme.colors.text.alternative};
`
const StyledBaseInput = styled(BaseInput)`
  width: 100%;
  padding-left: 48px;
  padding-right: ${({ $hasValue }) => ($hasValue ? "72px" : "8px")};
  background-color: transparent; 
  border: none; 
  &:focus {
    outline: none;
  }
`;

const SearchInput = ({placeholder, value, onChange}) => {
  return (
    <Container>
      <LeadingIcon/>
      <StyledBaseInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        $hasValue={Boolean(value)}/>
      {/* <TailingIconButton>
        <MicIcon/>
      </TailingIconButton> */}
    </Container>
  )
}

export default SearchInput
